import React from "react"
import MFALandingLegacy from "@views/mfa-landing-legacy"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - MFA for Any Application"
      keywords={[
        `engineid`,
        `security`,
        `mfa`,
        `multi factor`,
        `2fa`,
        `two factor`,
        `authentication`,
        `api`,
        `cloud`,
        `development`,
        `sdk`,
        `identity management`,
        `access management`,
      ]}
    />
    <MFALandingLegacy />
  </div>
)

export default IndexPage
